import { Alert, Link } from '@elementary/common-ui/components';
import useViewErrorsTracking from '@elementary/common-ui/hooks/tracking/useViewErrorsTracking';
import { extractApiContext } from '@elementary/common-ui/utils/errorTracking';
import { useLocation } from 'react-router-dom';
import useSupportChat from 'shared/hooks/useSupportChat';

type Props = {
  error?: Error;
  errorName?: 'ApiError' | 'ReactRenderingError';
  page?: string;
};

const PanelError = ({ error, errorName, page }: Props) => {
  const supportChat = useSupportChat();
  const { pathname } = useLocation();

  const apiContext =
    errorName === 'ApiError' ? extractApiContext(error) : undefined;

  useViewErrorsTracking({
    error,
    errorName,
    context: {
      component: 'PanelError',
      page,
      appState: {
        currentRoute: pathname,
      },
      ...(apiContext && { api: apiContext }),
      tags: [
        'side-panel',
        errorName === 'ApiError' ? 'api-error' : 'render-error',
      ],
    },
  });

  return (
    <Alert title="An internal error occurred." severity="error">
      Please try again or{' '}
      <Link onClick={supportChat.show} href="#">
        contact us
      </Link>{' '}
      if the error persists.
    </Alert>
  );
};

export default PanelError;
